<template lang="pug">
el-dialog.modal-justificativa-restricoes(
    :visible.sync='mostrarDialog',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    width='500px'
)
    div(
        style='background: white; height: auto; padding: 20px; border-radius: 5px'
    )
        section.mb-4.template(slot='title')
            .modal-justificativa-restricoes__header
                .modal-justificativa-restricoes__header--title
                    | {{ $t('mensagens.operacao.monitoramento.restricoesInibidas') }}

        section.mb-4.template(slot='body')
            .modal-justificativa-restricoes__body(v-if="dadosInibicao.operacaoSelecionada")
                p.modal-justificativa-restricoes__body--title
                    | {{ $t('mensagens.operacao.titulo') }}:
                    | {{ dadosInibicao.operacaoSelecionada.operacao.identificador }}
                p.modal-justificativa-restricoes__body--value
                    | {{ $t('mensagens.operacao.tabela.nome') }}:
                    | {{ dadosInibicao.operacaoSelecionada.operacao.nome }}
                p.modal-justificativa-restricoes__body--value
                    | {{ $t('mensagens.operacao.justificativa') }}:
                    | {{ dadosInibicao.operacaoSelecionada.justificativa }}
                p.modal-justificativa-restricoes__body--value
                    | {{ $t('mensagens.operacao.formularioGeral.descricao') }}:
                    | {{ dadosInibicao.operacaoSelecionada.descricaoJustificativa }}
                p.modal-justificativa-restricoes__body--value
                    | {{ $t('mensagens.operacao.monitoramento.dataInibicao') }}:
                    | {{ dadosInibicao.operacaoSelecionada.data }}
                p.modal-justificativa-restricoes__body--value
                    | {{ $t('mensagens.comuns.usuario') }}:
                    | {{ dadosInibicao.operacaoSelecionada.nomeUsuario }}
                div(v-if='dadosInibicao.outrasOperacoes')
                    hr
                    p.modal-justificativa-restricoes__body--title
                        | {{ $t('mensagens.operacao.monitoramento.outraOperacaoRestricaoInibida') }}
                    div(v-for='(inibicao, index) in dadosInibicao.outrasOperacoes')
                        hr(v-if='index > 0')
                        p.modal-justificativa-restricoes__body--value
                            | {{ $t('mensagens.operacao.tabela.id') }}:
                            | {{ inibicao.operacao.identificador }}
                        p.modal-justificativa-restricoes__body--value
                            | {{ $t('mensagens.operacao.tabela.nome') }}:
                            | {{ inibicao.operacao.nome }}
                        p.modal-justificativa-restricoes__body--value
                            | {{ $t('mensagens.operacao.justificativa') }}:
                            | {{ inibicao.justificativa }}
                        p.modal-justificativa-restricoes__body--value
                            | {{ $t('mensagens.operacao.formularioGeral.descricao') }}:
                            | {{ inibicao.descricaoJustificativa }}
                        p.modal-justificativa-restricoes__body--value
                            | {{ $t('mensagens.operacao.monitoramento.dataInibicao') }}:
                            | {{ inibicao.data }}
                        p.modal-justificativa-restricoes__body--value
                            | {{ $t('mensagens.comuns.usuario') }}:
                            | {{ inibicao.nomeUsuario }}

        section.modal-justificativa-restricoes__action
            BaseButton(type='primary', size='mini', @click='fechar')
                | {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalJustificativaRestricoes',

    components: {
        BaseButton
    },

    props: {
        idOperacao: {
            required: true
        },
        codigoRestricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mostrarDialog: false,
            dadosInibicao: {}
        };
    },

    watch: {
        mostrarDialog: function (value) {
            if (value) {
                this.buscarInibicao();
            }
        }
    },

    methods: {
        async buscarInibicao() {
            await OperacaoMonitoramentoService.buscarInibicaoRestricaoOperacao({
                idOperacao: this.idOperacao,
                codigoRestricao: this.codigoRestricao
            })
                .then(({ data }) => {
                    this.dadosInibicao = data;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.erroInibicaoRestricao')
                    })
                );
        },
        fechar() {
            this.mostrarDialog = false;
        }
    }
};
</script>

<style lang="scss">
.modal-justificativa-restricoes {
    display: flex;

    .modal-justificativa-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-justificativa-restricoes__header--title {
            font-size: 16px;
            font-weight: 600;
            word-wrap: break-word;
        }
    }

    .modal-justificativa-restricoes__body {
        width: 100%;
        max-width: 100%;
        overflow-y: scroll;
        height: 270px;

        .modal-justificativa-restricoes__body--title {
            font-weight: 600;
            font-size: 14px;
        }

        .modal-justificativa-restricoes__body--value {
            font-weight: 500;
            font-size: 14px;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
        }
    }

    .modal-justificativa-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }
}
</style>
